import React from "react";
import "./AddProducts.css";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";
import axios from "axios";
import Sellernav from "../Sellernav";
import toastify from "../../Util/toastify";
import BaseURL from "../../Util/BaseURL";
const AddProducts = () => {
  const [urls, setUrls] = useState([]);
  const [title, setTitle] = useState();
  const [category, setCategory] = useState();
  const [brand, setBrand] = useState();
  const [model, setModel] = useState();
  const [description, setDescription] = useState();
  const [price, setPrice] = useState();
  const [discount, setDiscount] = useState();
  const [quantity, setQuantity] = useState();
  const [sellerid, setSellerid] = useState();
  const [url, setUrl] = useState("");

  const [status, setStatus] = useState();
  var nav = useNavigate();
  //
  var token = sessionStorage.getItem("pic");
  const init = async () => {
    const res = await axios.post(
      `${BaseURL}addProducts`,
      {
        title,
        category,
        brand,
        model,
        description,
        quantity,
        status,
      },
      { headers: { Authorization: "Bearer " + token } }
    );
    const productid = res.data;
    urls.forEach(async (url) => {
      axios.post(
        `${BaseURL}addImages`,
        {
          productid,
          sellerid,
          url,
        },
        { headers: { Authorization: "Bearer " + token } }
      );
    });
    await axios.post(
      `${BaseURL}AddPrice`,
      {
        productid,
        sellerid,
        price,
        discount,
      },
      { headers: { Authorization: "Bearer " + token } }
    );
    // const data = res.status;
    // if (data === 200)
  };

  function navBack() {
    nav("/SellerPanel");
  }
  function submitProduct() {
    init();
    toastify("Product Added Successfully", "success");
    setUrls([]);
    setTitle("");
    setBrand("");
    setModel("");
    setCategory("");
    setDescription("");
    setPrice(0);
    setDiscount(0);
    setQuantity(0);
  }
  function showUploadWidget() {
    window.cloudinary.openUploadWidget(
      {
        cloudName: "vcart",
        uploadPreset: "ecommerce",
        sources: ["local", "url", "google_drive", "camera"],
        googleApiKey: "<image_search_google_api_key>",
        showAdvancedOptions: true,
        cropping: true,
        multiple: false,
        defaultSource: "local",
        styles: {
          palette: {
            window: "#ffffff",
            sourceBg: "#f4f4f5",
            windowBorder: "#90a0b3",
            tabIcon: "#000000",
            inactiveTabIcon: "#555a5f",
            menuIcons: "#555a5f",
            link: "#0433ff",
            action: "#339933",
            inProgress: "#0433ff",
            complete: "#339933",
            error: "#cc0000",
            textDark: "#000000",
            textLight: "#fcfffd",
          },
          fonts: {
            default: null,
            "'Fira Sans', sans-serif": {
              url: "https://fonts.googleapis.com/css?family=Fira+Sans",
              active: true,
            },
          },
        },
      },
      (err, info) => {
        if (!err) {
          if (info.event === "success") {
            setUrl(info.info.url);
            toastify("Image uploaded successfully", "success");
          }
        }
      }
    );
  }
  useEffect(() => {
    setStatus(true);
    setSellerid(sessionStorage.getItem("user"));
    if (url != "") {
      document.getElementById(
        "url"
      ).innerHTML += `<a href=${url} target='_blank' className='url-box mx-auto'>${url.substring(
        37
      )}</a><br/>`;
      setUrls((urls) => [...urls, url]);
      setUrl("");
    }
  }, [url]);

  return (
    <>
      <Sellernav />
      <section id="hero">
        <div className="hero-container">
          <div className="hero-logo row">
            <h1 className="font-weight-bold col">Add Products</h1>
          </div>
        </div>
      </section>
      <div className="form-container">
        <form action="" className="checkout-form">
          <div className="input-line">
            <label htmlFor="title">Title</label>
            <input
              type="text"
              name="title"
              id="title"
              placeholder="Title of the Product"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </div>
          <div className="input-line">
            <label htmlFor="category">Category</label>
            <input
              type="text"
              name="category"
              id="category"
              placeholder="Category of the Product"
              value={category}
              onChange={(e) => setCategory(e.target.value)}
            />
          </div>
          <div className="input-container">
            <div className="input-line">
              <label htmlFor="brand">Brand</label>
              <input
                type="text"
                name="brand"
                id="brand"
                placeholder="Brand of the Product"
                value={brand}
                onChange={(e) => setBrand(e.target.value)}
              />
            </div>
            <div className="input-line">
              <label htmlFor="model">Model</label>
              <input
                type="text"
                name="model"
                id="model"
                placeholder="Model of the Product"
                value={model}
                onChange={(e) => setModel(e.target.value)}
              />
            </div>
          </div>
          <div className="input-line">
            <label htmlFor="description">Description</label>
            <input
              type="text"
              name="description"
              id="description"
              placeholder="Description of the product"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>
          <div className="input-line">
            <label htmlFor="quantity">Quantity</label>
            <input
              type="number"
              name="quantity"
              id="quantity"
              placeholder="Quantity of the product"
              value={quantity}
              onChange={(e) => setQuantity(e.target.value)}
            />
          </div>
          <div className="input-container">
            <div className="input-line">
              <label htmlFor="price">Price</label>
              <input
                type="number"
                name="price"
                id="price"
                placeholder="Price of the product"
                value={price}
                onChange={(e) => setPrice(e.target.value)}
              />
            </div>
            <div className="input-line">
              <label htmlFor="discount">Discount</label>
              <input
                type="number"
                name="discount"
                id="discount"
                placeholder="Discount of the product"
                value={discount}
                onChange={(e) => setDiscount(e.target.value)}
              />
            </div>
          </div>
          <div className=" row">
            <div className="col prev">
              <button
                type="button"
                className="btn btn-success back"
                onClick={() => {
                  navBack();
                }}
              >
                Back
              </button>
            </div>
            <div className=" col uploadImage">
              <button
                type="button"
                className="btn btn-success upload"
                onClick={() => {
                  showUploadWidget();
                }}
              >
                Upload Picture
              </button>
            </div>
            <div className="next col">
              <button
                type="button"
                className="btn btn-success submitbtn"
                onClick={() => {
                  submitProduct();
                }}
              >
                Submit
              </button>
            </div>
          </div>
          <div id="url"></div>
        </form>
      </div>
    </>
  );
};

export default AddProducts;
